module.exports = new __parcel__URL__("list-merge-modal-multi-project-dark.e891dbcf.png").toString();